import { useEffect } from 'react';
import { motion, useAnimate, stagger } from 'framer-motion';
import { cn } from '../utils/cn';
import './TextGenerateEffect.css';

/**
 * Word-by-word blur-to-focus reveal (shadcn.io / Aceternity "Text Generate Effect" pattern).
 */
export default function TextGenerateEffect({
  words,
  className,
  duration = 0.5,
  staggerDelay = 0.12,
  filter = true,
  ariaHidden = false,
}) {
  const [scope, animate] = useAnimate();
  const tokens = String(words || '')
    .trim()
    .split(/\s+/)
    .filter(Boolean);

  useEffect(() => {
    if (tokens.length === 0) return undefined;

    animate(
      'span[data-text-gen-word]',
      {
        opacity: 1,
        filter: filter ? 'blur(0px)' : 'none',
      },
      {
        duration,
        delay: stagger(staggerDelay, { from: 'first' }),
      }
    );
  }, [words, duration, staggerDelay, filter, animate, tokens.length]);

  if (tokens.length === 0) return null;

  return (
    <motion.span
      ref={scope}
      className={cn('text-generate-root', className)}
      {...(ariaHidden ? { 'aria-hidden': true } : {})}
    >
      {tokens.map((word, idx) => (
        <span
          key={`${word}-${idx}`}
          data-text-gen-word
          className={cn('text-generate-word', !filter && 'text-generate-word--no-filter')}
        >
          {word}
          {idx < tokens.length - 1 ? '\u00A0' : null}
        </span>
      ))}
    </motion.span>
  );
}
